import React from 'react';
import { Container, Row, Card, Col, Alert, Button, ListGroup, Modal, Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { DashboardOutlined, OpenInBrowserOutlined } from '@material-ui/icons';
import Chart from 'react-apexcharts'
import MasterAgentService from 'services/master-agent-request';
import Loading from 'components/Loading';
import { useCompany, useUser } from 'models';
import { formatMoney } from 'helpers/Currency';

const MasterAgentView = () => {
  const user = useUser()
  const { company } = useCompany()
  const [filters, setFilters] = useState({
    format: "chart",
    company: company ? company.document : ""//user.companies.map(c => c.document).join(',')
  });
  const [mBarData, setMBarData] = useState([])
  const [mBarMonths, setMBarMonths] = useState([])
  const [pie, setPie] = useState({
    series: [],
    labels: []
  })
  const [bar, setBar] = useState({
    data: [],
    series: []
  })
  const [notifications, setNotifications] = useState([])
  const [isLoadingCommissions, setIsLoadingCommissions] = useState(false)
  const [isLoadingContracts, setIsLoadingContracts] = useState(false)

  const [showInfoContract, setShowInfoContract] = useState(false)
  const [contract, setContract] = useState({})

  useEffect(() => {
    async function init() {
      getCommissionsPeriod()
      getContractsProvider()
    }
    init()
  }, [])

  const getCommissionsPeriod = () => {
    setIsLoadingCommissions(true)
    MasterAgentService
      .getAllComissions({ ...filters, chart_type: 'bar' })
      .then(res => {
        const { data, series, months } = res.data.chart_data.multiple
        setMBarMonths(months)
        setMBarData(series.map((s, i) => ({
          name: s,
          data: data[i]
        })))
        setBar(res.data.chart_data.single)
      })
      .finally(() => setIsLoadingCommissions(false))

  }

  const getContractsProvider = () => {
    setIsLoadingContracts(true)
    MasterAgentService
      .getAllContracts({ ...filters, chart_type: 'pie', notifications: true })
      .then(res => {
        setPie(res.data.chart_data)
        setNotifications(res.data.notifications_due)
      })
      .finally(() => setIsLoadingContracts(false))
  }

  const formatValue = val => val.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });

  const chartBar = () => {
    return (
      <Chart
        options={{
          dataLabels: {
            enabled: false
          },
          colors: ['#2FF0B3'],
          xaxis: {
            categories: bar.series
          },
          yaxis: {
            labels: {
              formatter: function (val, index) {
                return formatValue(val)
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return formatValue(val)
              }
            }
          }
        }}
        series={[
          {
            name: "Total Acumulado",
            data: bar.data
          }
        ]}
        type="bar"
        height="350"
      />
    )
  }

  const chartMultipleBar = () => {
    return (
      <Chart
        options={{
          chart: {
            type: 'bar'
          },
          dataLabels: {
            enabled: false
          },
          colors: ['#010DD6', '#98EB0E', '#EBE701', '#01EBC3'],
          xaxis: {
            categories: mBarMonths,
          },
          yaxis: {
            labels: {
              formatter: function (val, index) {
                return formatValue(val)
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return formatValue(val)
              }
            }
          }
        }}
        series={mBarData}
        height="350"
        type="bar"
      />
    )
  }

  const chartPie = () => {
    return (
      <Chart
        options={{
          chart: {
            width: 300,
            type: 'pie',
          },
          dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
              const value = opts.w.config.series[opts.seriesIndex]
              return `${formatValue(value)}`
              //return parseFloat(val).toFixed(2) + "%"
            }
          },
          colors: ['#254441', '#EF3054', '#F8F32B', '#7B8CDE', '#43AA8B', '#372554', '#4281A4'],
          tooltip: {
            y: {
              formatter: function (val, opts) {
                return formatValue(val)
              }
            }
          },
          labels: pie.labels.map(l => l == "" ? "Sem Nome" : l),
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }}
        series={pie.series}
        type="pie"
        width="400"
      />
    )
  }

  const handleCloseInfoContract = () => {
    setShowInfoContract(false)
    setContract({})
  }

  function showInfoContractModal(item) {
    setContract(item.full)
    setShowInfoContract(true)
  }

  return (
    <Container className="mb-5" fluid>
      <Row className="mt-4">
        <Col md="6" className="d-flex p-0">
          <DashboardOutlined className="icon-title" />
          <h5 className="title-dashboard">MyScanSource</h5>
        </Col>
      </Row>
      <Row className="p-0">
        <Col className="col-6 d-flex">
          <Card.Body className="shadow bg-white rounded m-2 col-12">
            <Col md="12">
              <span className="dashboard-card-h5 text-left">
                Contratos X Fornecedor
              </span>
            </Col>
            <Col md="12">
              <hr></hr>
            </Col>
            <Col md="12" className="d-flex justify-content-center align-items-center" style={{ minHeight: '100px' }}>
              {isLoadingContracts ? (
                <Loading page />
              ) : (<>
                {pie.series.length > 0 ? chartPie() : (
                  <span className="h4">Sem dados</span>
                )}
              </>)}
            </Col>
          </Card.Body>
        </Col>
        <Col className="col-6 d-flex">
          <Card.Body className="shadow bg-white rounded m-2 col-12">
            <Col md="12">
              <span className="dashboard-card-h5 text-left">
                Contratos próximos a vencer
              </span>
            </Col>
            <Col md="12">
              <hr></hr>
            </Col>
            <Col
              md="12"
              style={{ overflowY: !isLoadingContracts && notifications.length > 0 ? 'auto' : 'hidden', maxHeight: '250px' }}
            >
              {isLoadingContracts ? (
                <Loading page />
              ) : (<>
                {notifications.length > 0 ? (
                  <ListGroup as="ol" numbered>
                    {notifications.map((n, k) => (
                      <ListGroup.Item
                        key={k}
                        as="li"
                      >
                        <div className="d-flex justify-content-between align-items-start w-auto">
                          <span>Contrato - <b><a href="javascript:;" onClick={() => showInfoContractModal(n)}>{n.contract_number} <OpenInBrowserOutlined fontSize='small' /></a></b></span>
                          <span>Vence - <b>{n.due_date}</b></span>
                          <span><b>{n.remaining_days}</b> Dias</span>
                        </div>

                        <div className="d-flex justify-content-between align-items-start w-auto row">
                          <div className='col-7'>
                            <span>{n.company}</span>
                          </div>
                          <div className='col-5'>
                            <span className='float-right'>{n.provider}</span>
                          </div>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                ) : (
                  <span className="h4">Sem contratos perto de vencer</span>
                )}
              </>)}
            </Col>
          </Card.Body>
        </Col>
        <Col className="col-12 d-flex">
          <Card.Body className="shadow bg-white rounded m-2 col-12 pr-2">
            <Col md="12">
              <span className="dashboard-card-h5 text-left">
                Comissões
              </span>
            </Col>
            <Col md="12">
              <hr></hr>
            </Col>
            <Col md="12" style={{ minHeight: '100px' }}>
              {isLoadingCommissions ? (
                <Loading page />
              ) : (<>
                {bar.data.length > 0 ? chartBar() : (
                  <span className="h4">Sem dados</span>
                )}
              </>)}
            </Col>
          </Card.Body>
        </Col>

        <Col className="col-12 d-flex">
          <Card.Body className="shadow bg-white rounded mt-2 col-12">
            <Col md="12">
              <span className="dashboard-card-h5 text-left">
                Comissões: Previsão para os próximos 4 meses
              </span>
            </Col>
            <Col md="12">
              <hr></hr>
            </Col>
            <Col md="12" style={{ minHeight: '100px' }}>
              {isLoadingCommissions ? (
                <Loading page />
              ) : (<>
                {mBarData.length > 0 ? chartMultipleBar() : (
                  <span className="h4">Sem dados</span>
                )}
              </>)}
            </Col>
            <Col md="12">
              <Alert variant="warning">
                <small>
                  <b>IMPORTANTE:</b> Os valores informados podem sofrer alterações sem aviso prévio.
                  Atente-se à condição de cada comissão. Somente <b>APTAS</b> estão liberadas para pagamento.
                  As comissões em <b>PREVISTAS</b> não são definitivas e poderão ser canceladas, não havendo garantia de seu recebimento.
                  Para solicitar sua comissão acessa a área restrita no site da Scansource em <a target="_blank" href="https://www.scansource.com.br">https://www.scansource.com.br</a>
                </small>
              </Alert>
            </Col>
          </Card.Body>
        </Col>
      </Row>
      <Modal
        centered
        size='lg'
        show={showInfoContract && ('cols' in contract && 'data' in contract)}
        onHide={handleCloseInfoContract}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {('cols' in contract && 'data' in contract) ? (
            <Table striped bordered>
              <tbody>
                {contract.cols.map((col, idx) => {
                  return (
                    <tr key={idx}>
                      <td className='fw-bold'>{col == "Number" ? "Nº Contrato" : col}</td>
                      <td>
                        {idx == 9 ? formatMoney(contract.data[idx]) : contract.data[idx]}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          ) : (<></>)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseInfoContract()}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}


export default MasterAgentView;